import React, { Component } from "react";
import { Navigate } from "react-router-dom";
import axios from "axios";
import Box from "@mui/material/Box";
import Card from "@mui/material/Card";
import TextField from "@mui/material/TextField";
import Typography from "@mui/material/Typography";

import AgriActionButton from "components/AgriTheme/AgriActionButton";
import Constants from "../Helpers/Constants";
import MDSnackbar from "components/MDSnackbar";

export default class Signin extends Component {
  state = {
    mobile: "",
    password: "",
    redirect: false,
    message: "",
    notification: false,
    noticolor: "success",
    loading: false,
  };

  handleInput = (e) => {
    this.setState({
      [e.target.name]: e.target.value,
    });
  };

  handleLogin = (e) => {
    e.preventDefault();

    this.setState({ loading: true });

    axios
      .post(Constants.postUrls.employerLogin, {
        mobile: this.state.mobile,
        password: this.state.password,
      })
      .then((resp) => {
        if (resp.data.status === "success") {
          localStorage.setItem("accessToken", resp.data.token);
          localStorage.setItem("admin_details", JSON.stringify(resp.data.details));
          this.setState({
            message: resp.data.message,
            notification: true,
          });
          setTimeout(() => {
            this.setState(
              {
                message: "",
                notification: false,
                redirect: true,
                loading: false,
              },
              () => {
                window.location.assign("/dashboard");
              }
            );
          }, 1500);
        }
      })
      .catch((err) => {
        this.setState({
          message: err?.response?.data?.message || "Unable to sign in.",
          notification: true,
          noticolor: "error",
          loading: false,
        });
        setTimeout(() => {
          this.setState({
            notification: false,
            noticolor: "success",
          });
        }, 3000);
      });
  };

  render() {
    if (this.state.redirect === true) {
      return <Navigate to="/" />;
    }

    return (
      <Box
        minHeight="100vh"
        display="grid"
        placeItems="center"
        px={2}
        sx={{
          background:
            "radial-gradient(circle at top left, rgba(94,168,255,0.22) 0%, rgba(8,16,28,0) 26%), radial-gradient(circle at top right, rgba(76,195,138,0.16) 0%, rgba(8,16,28,0) 28%), linear-gradient(180deg, #07111d 0%, #050c15 100%)",
        }}
      >
        <Card
          sx={{
            width: "100%",
            maxWidth: 480,
            borderRadius: "28px",
            overflow: "hidden",
            border: "1px solid rgba(126, 170, 220, 0.12)",
            background: "rgba(10, 20, 34, 0.94)",
            boxShadow: "0 28px 72px rgba(0,0,0,0.42)",
          }}
        >
          <Box
            px={4}
            py={4}
            sx={{
              background: "linear-gradient(135deg, #0d1d31 0%, #143b30 58%, #1f5ea5 100%)",
            }}
          >
            <Box
              width={62}
              height={62}
              borderRadius="22px"
              display="grid"
              placeItems="center"
              mb={2}
              sx={{
                backgroundColor: "rgba(255,255,255,0.14)",
                color: "#fff",
                border: "1px solid rgba(255,255,255,0.12)",
              }}
            >
              <Typography fontWeight={800} fontSize="1.25rem">
                AQ
              </Typography>
            </Box>
            <Typography color="#ffffff" fontSize="2rem" fontWeight={800}>
              AgriQuiz Admin
            </Typography>
            <Typography color="rgba(225,237,255,0.74)" fontSize="0.95rem" mt={1}>
              Manage content, tests, users and support from one focused workspace.
            </Typography>
          </Box>

          <Box p={4} component="form" onSubmit={this.handleLogin} sx={{ background: "transparent" }}>
            <TextField
              label="Mobile"
              fullWidth
              name="mobile"
              value={this.state.mobile}
              onChange={this.handleInput}
              margin="normal"
            />
            <TextField
              label="Password"
              fullWidth
              type="password"
              name="password"
              value={this.state.password}
              onChange={this.handleInput}
              margin="normal"
            />

            <Box mt={3}>
              <AgriActionButton
                fullWidth
                color="primary"
                type="submit"
                disabled={this.state.loading}
              >
                {this.state.loading ? "Signing In..." : "Sign In"}
              </AgriActionButton>
            </Box>
          </Box>
        </Card>

        <MDSnackbar
          color={this.state.noticolor}
          icon="notifications"
          title="AgriQuiz"
          content={this.state.message}
          dateTime="Just now"
          open={this.state.notification}
        />
      </Box>
    );
  }
}
